import 'lib/view-helper';
import Chaplin from 'chaplin';
import Handlebars from 'handlebars/runtime';

const View = Chaplin.View.extend({
  getTemplateFunction: function () {
    //TODO: Review this in regards to non-page views
    // Template compilation
    // --------------------

    // This demo uses Handlebars templates to render views.
    // The template is loaded with Require.JS and stored as string on
    // the view prototype. On rendering, it is compiled on the
    // client-side. The compiled template function replaces the string
    // on the view prototype.
    //
    // In the end you might want to precompile the templates to JavaScript
    // functions on the server-side and just load the JavaScript code.
    // Several precompilers create a global JST hash which stores the
    //
    // template functions. You can get the function by the template name:
    // templateFunc = JST[@templateName];

    const template = this.template;
    let templateFunc = null;

    if (typeof template === 'string') {
      // Compile the template string to a function and save it
      // on the prototype. This is a workaround since an instance
      // shouldn’t change its prototype normally.
      templateFunc = Handlebars.compile(template);
      this.constructor.prototype.template = templateFunc;
    } else {
      templateFunc = template;
    }

    return templateFunc;
  },
  /**
   * This is an exact copy of the default Chaplin render method with one exception. allowProtoPropertiesByDefault is flipped to true
   * https://github.com/chaplinjs/chaplin/blob/master/src/chaplin/views/view.coffee#L422
   *
   * This is needed for 3 reasons:
   * Handlebars changed how it iterates over properties, so that the prototype properties were not included.
   * Chaplin will not be updated, and it copies properties on to the prototype.
   * Chaplin does not have an api to send Handlebars options into the template
   *
   * Handlebars added an option `allowProtoPropertiesByDefault` to allow this behavior. This is false by default because it
   * has security implications. See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access
   */
  render: function () {
    let el, html;
    if (this.disposed) {
      return false;
    }
    const templateFunc = this.getTemplateFunction();
    if (typeof templateFunc === 'function') {
      html = templateFunc(this.getTemplateData(), { allowProtoPropertiesByDefault: true });
      if (this.noWrap) {
        el = document.createElement('div');
        el.innerHTML = html;
        if (el.children.length > 1) {
          throw new Error('There must be a single top-level element when ' + 'using `noWrap`.');
        }
        this.undelegateEvents();
        this.setElement(el.firstChild, true);
      } else {
        this.el.innerHTML = html;
      }
    }
    return this;
  },

  keepSubviews: function (keep) {
    if (this.subviews && Array.isArray(this.subviews)) {
      this.subviews.forEach(subview => {
        // prevents: TypeError "Cannot add property keepElement, object is not extensible"
        subview = Object.assign({}, subview, { keepElement: keep });

        if (subview.keepSubviews) {
          subview.keepSubviews(keep);
        }
      });
    }
  },
});

export default View;
